import { splitAndTrimCategories } from 'store/userOptions/transformPoiOptions';

export type ProductTemplatePoiCategoryDisplay = {
  leafName: string;
  rootCategoryType: string;
  parentCategory: string;
  tooltip: string;
};

export const derivePoiDisplayFromProductTemplateCategoryPath = (
  categoryPath: string,
): ProductTemplatePoiCategoryDisplay => {
  const segments = splitAndTrimCategories(categoryPath);
  const segmentCount = segments.length;
  const leafName = segments[segmentCount - 1];
  const parentCategory = segmentCount >= 2 ? segments[segmentCount - 2] : '';

  return {
    leafName,
    rootCategoryType: segments[0],
    parentCategory,
    tooltip: segments.join(' > '),
  };
};
